/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type UpdateSlackIncomingHookPathParams = NonNullable<
  operations['updateSlackIncomingHook']['parameters']['path']
>;

export type UpdateSlackIncomingHookRequestBody = OperationRequestBodyContent<operations['updateSlackIncomingHook']>;

export interface Input extends UpdateSlackIncomingHookPathParams {
  apiVersion?: string;
  body: UpdateSlackIncomingHookRequestBody;
}

export async function updateSlackIncomingHook(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/api/v2/integrations/slack/{id}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
